module.exports = __webpack_public_path__ + "images/2-ru.9c9e0cca983ef1b52243d09539da2118.jpg";